import { useEffect, useState } from "react";
import { UserPlus, UserMinus } from "lucide-react";
import { toast } from "sonner";
import { useAuth, api, goToLogin } from "@/contexts/AuthContext";

export default function FollowButton({ personId, isDemo }) {
  const { user } = useAuth();
  const [state, setState] = useState({
    following: false,
    follower_count: 0,
    following_count: 0,
  });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!personId || isDemo) return;
    api
      .get(`/users/${personId}/follow-state`)
      .then((r) => setState(r.data))
      .catch(() => {});
  }, [personId, isDemo, user?.user_id]);

  if (isDemo || (user && user.user_id === personId)) {
    return null;
  }

  const toggle = async () => {
    if (!user) return goToLogin(window.location.pathname);
    setBusy(true);
    try {
      const req = state.following
        ? api.delete(`/users/${personId}/follow`)
        : api.post(`/users/${personId}/follow`);
      const { data } = await req;
      setState(data);
      toast.success(state.following ? "Unfollowed." : "Following.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Couldn't update follow.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-4 flex items-center gap-3">
      <button
        onClick={toggle}
        data-testid="follow-toggle"
        disabled={busy}
        className={`inline-flex items-center gap-1.5 h-9 px-4 rounded-full text-sm font-semibold transition-colors ${
          state.following
            ? "bg-white text-[#111827] ring-1 ring-[#E5E7EB] hover:ring-[#111827]"
            : "bg-[#111827] text-white hover:bg-black"
        }`}
      >
        {state.following ? <UserMinus size={14} /> : <UserPlus size={14} />}
        {state.following ? "Following" : "Follow"}
      </button>
      <span className="text-xs text-[#9CA3AF]">
        <span className="font-semibold text-[#111827]">
          {state.follower_count}
        </span>{" "}
        {state.follower_count === 1 ? "follower" : "followers"}
      </span>
    </div>
  );
}
